import type { BoxProps } from '@shopify/polaris';

import { BOX_BORDER_WRAPPER, BOX_BORDER_COLUMN } from '../configs';
import { BOX_BORDER } from '~/modules/campaign-product-price';
import { InlineGrid, Box } from '@shopify/polaris';
import { cls } from '~/utils';

// Interfaces for CardGridWrapper
export interface CardGridWrapperColumn {
  children: React.ReactNode;
}
export interface CardGridWrapperSuffix {
  children: React.ReactNode;
}
export interface CardGridWrapperFooter {
  children: React.ReactNode;
}

export const CardGridWrapper: React.FC<{
  columns: CardGridWrapperColumn[];
  footers?: CardGridWrapperFooter[];
  suffix?: CardGridWrapperSuffix;
  boxProps?: BoxProps;
  allVariantsHaveIssues?: boolean;
}> = ({
  columns,
  footers,
  suffix,
  boxProps = { ...BOX_BORDER_WRAPPER, background: 'bg-fill' },
  allVariantsHaveIssues,
}) => {
  return (
    <InlineGrid {...(suffix && { columns: '1fr 32px' })} gap={'400'} alignItems="center">
      <Box overflowX="hidden" overflowY="hidden" {...boxProps}>
        <div
          className={cls({
            'border-solid border-[1px] rounded-lg border-[#FFC879] overflow-hidden':
              allVariantsHaveIssues,
          })}
        >
          <InlineGrid columns={columns.length}>
            {columns.map((item, index) => (
              <Box key={index} {...(index !== columns.length - 1 && BOX_BORDER_COLUMN)}>
                <div className="h-full">{item.children}</div>
              </Box>
            ))}
          </InlineGrid>
        </div>
        {footers && (
          <InlineGrid columns={footers.length} alignItems="start">
            {footers?.map((footer, index) => (
              <Box
                key={index}
                borderColor={BOX_BORDER['borderColor']}
                borderBlockStartWidth={BOX_BORDER['borderWidth']}
                overflowX="hidden"
                overflowY="hidden"
              >
                {footer.children}
              </Box>
            ))}
          </InlineGrid>
        )}
      </Box>
      {suffix && <div>{suffix.children}</div>}
    </InlineGrid>
  );
};
